import { NavLink } from "react-router-dom";
import { Home, Camera, ListChecks, LineChart } from "lucide-react";

const tabs = [
  { to: "/", icon: Home, label: "Home", testid: "nav-home" },
  { to: "/log", icon: Camera, label: "Log", testid: "nav-log" },
  { to: "/history", icon: ListChecks, label: "History", testid: "nav-history" },
  { to: "/insights", icon: LineChart, label: "Insights", testid: "nav-insights" },
];

export default function BottomNav() {
  return (
    <nav
      className="fixed left-1/2 -translate-x-1/2 w-full max-w-md z-[60] pt-2 px-3 backdrop-blur-xl bg-white/85 border-t border-sand"
      style={{ bottom: 'calc(56px + env(safe-area-inset-bottom, 0px))', paddingBottom: '0.5rem' }}
      data-testid="bottom-nav"
    >
      <ul className="flex items-center justify-around">
        {tabs.map(({ to, icon: Icon, label, testid }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={to === "/"}
              data-testid={testid}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 px-4 py-2 rounded-2xl transition-colors tap-shrink ${
                  isActive ? "bg-sage-light text-charcoal" : "text-slate2 hover:text-charcoal"
                }`
              }
            >
              <Icon size={22} strokeWidth={1.75} />
              <span className="text-[11px] font-medium">{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
